/**
 * channelsRail.tsx
 */
import ArrowsSelector from '../nav/arrowsSelector';
import ChannelsRailWrapperContainer from '@components/atoms/container/channelsRailWrapperContainer';
import EpgEvent from '@shared/classes/epgEvent';
import Focus from '@shared/types/enums/focus';
import MainContext from '@shared/components/utils/context/mainContext';
import SquareCard from '@components/elements/card/ui/cards/squareCard';
import useRail from '../../lib/useRail';
import useStableSelectHandler from '../../lib/useStableSelectHandler';
import { memo, useContext } from 'react';

/**
 * Maximum number of items to display in the channels rail.
 */
const MAX_CHANNELS_ITEMS = 14;

/**
 * Channels rail component. Displays a list of channels.
 */
function ChannelsRail() {
  const { channels, config, selectAsset } = useContext(MainContext);
  const { focused, hovered, hIndex, callbacks } = useRail(
    channels?.id || '',
    Focus.CHANNELS_RAIL
  );
  const getClickHandler = useStableSelectHandler(
    channels?.id || '',
    selectAsset
  );
  return (
    <ChannelsRailWrapperContainer
      displayFilter={config?.display?.filter}
      displayRail={config.display.channels}
      {...callbacks}
    >
      <div>
        {(channels?.data as EpgEvent[])?.map((item: EpgEvent, idx: number) => {
          const display = Math.abs(idx - hIndex) < MAX_CHANNELS_ITEMS;
          const hide = hIndex > idx;

          return display ? (
            <SquareCard
              key={`${item.id}-${idx}`}
              focused={focused && hIndex === idx}
              hide={hide}
              item={item}
              onClick={getClickHandler(idx)}
            />
          ) : null;
        })}
        <ArrowsSelector hovered={hovered} hIndex={hIndex} rail={channels} />
      </div>
    </ChannelsRailWrapperContainer>
  );
}

export default memo(ChannelsRail);
